// extracted by mini-css-extract-plugin
export var dropdown = "_un-0";
export var imageWrapper = "_un-3";
export var itemNameContainer = "_un-1";
export var productImage = "_un-2";
export var spinnerWrapper = "_un-4";